// Redirect tracking utility

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
  }
}

export function trackRedirectIfPresent(): void {
  // Check for redirect parameter on page load
  const urlParams = new URLSearchParams(window.location.search);
  const redirectSource = urlParams.get('redirected');

  if (redirectSource) {
    // Fire Google Analytics event
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'domain_redirect', {
        event_category: 'traffic_source',
        event_label: redirectSource,
        source_domain: redirectSource,
        destination_domain: window.location.hostname,
        custom_parameter_1: window.location.pathname
      });
    }

    // Clean up URL by removing the redirect parameter
    urlParams.delete('redirected');

    // Build new URL without the parameter
    const newSearch = urlParams.toString();
    const newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;

    // Update URL without page reload using pushState
    window.history.replaceState({}, '', newUrl);

    console.log('Redirect tracked:', redirectSource, '→', window.location.hostname);
  }
}